import React from 'react';
import { Link } from 'react-router-dom';
import Practices from '../../api/Practices';

const Practice3 = props => {
	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<section className='bg-[#f5f5f5] pt-[95px] pb-[70px]'>
			<div className='wraper'>
				<div className='col-span-12 text-center'>
					<div className='mb-[60px]'>
						<span className='text-[16px] text-[#ada282]'>Domaine d'activité</span>
						<h2
							className=" text-[36px] md:text-[26px] font-medium text-[#333] pb-[20px] relative before:absolute before:content-['']
                                        before:left-[50%] before:bottom-0 before:transform before:-translate-x-1/2 before:w-[60px] before:h-[3px]
                                        before:bg-[#c0b596]"
						>
							Comment pouvons-nous vous aider ?
						</h2>
					</div>
				</div>
				<div className='grid grid-cols-12 gap-3'>
					{Practices.map((practice, Pitem) => (
						<div className='col-span-4 md:col-span-6 sm:col-span-12 mb-5' key={Pitem}>
							<div className='group text-center py-[40px] border border-[#c0b596]'>
								<div className='h-[80px] w-[80px] mx-auto'>
									<div className='h-[80px] w-[80px] leading-[75px] text-center flex justify-center items-center'>
										{/* <i
											className={`fi ${practice.icon}  text-[50px]  col:leading-[45px] transition-all text-[#c0b596] group-hover:text-[#999]`}
										></i> */}
										{/* {practice.icon2} */}
										<img
											alt='Cog SVG Vector Icon'
											width='60'
											height='60'
											src={`${practice.icon}`}
											style={{ color: 'red', width: '60px', height: '60px' }}
										></img>
									</div>
								</div>
								<div className='px-[50px]'>
									<h3 className="text-[#373737] text-[24px] col:text-[20px] font-medium relative  pt-[24px] mb-[10px] hover:text-[#c0b596] transition-all before:absolute before:content-[''] before:left-1/2 before:top-[10px] before:transform before:-translate-x-1/2 before:w-[65px] before:h-[1px] before:bg-[#c0b596]">
										<Link onClick={ClickHandler} to={`/matieres/${practice.slug}`}>
											{practice.sTitle && (
												// This part is to allow the line break and space on shorter titles
												<>
													{practice.sTitle.split('\n').map((part, index) => (
														<React.Fragment key={index}>
															{part}
															{index < practice.sTitle.split('\n').length - 1 && <br />}
														</React.Fragment>
													))}
												</>
											)}
										</Link>
									</h3>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Practice3;
